export function newsletterEvent(formData) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'inscriptionInfolettre',
    email: formData.get('acf[field_newsletter_email]'),
    phoneNumber: formData.get('acf[field_newsletter_phone]'),
    firstName: formData.get('acf[field_newsletter_firstname]'),
    lastName: formData.get('acf[field_newsletter_lastname]'),
  });
}

export function contactEvent(formData) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'formulaireContact',
    email: formData.get('acf[field_form_contact_email]'),
    phoneNumber: formData.get('acf[field_form_contact_phone]'),
    firstName: formData.get('acf[field_form_contact_firstname]'),
    lastName: formData.get('acf[field_form_contact_lastname]'),
  });
}

export function unitEvent(formData) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'formulaireContact',
    formType: 'formulaire-unite',
    email: formData.get('acf[field_form_unit_email]'),
    phoneNumber: formData.get('acf[field_form_unit_phone]'),
    firstName: formData.get('acf[field_form_unit_firstname]'),
    lastName: formData.get('acf[field_form_unit_lastname]'),
  });
}

export default function googleAnalytics() {
  window.dataLayer = window.dataLayer || [];

  //Hubspot appointment form
  window.addEventListener('message', function (event) {
    if (event.origin === 'https://meetings.hubspot.com' && event.data.meetingBookSucceeded) {
      const contact = event.data.meetingsPayload.bookingResponse.postResponse.contact;
      window.dataLayer.push({
        event: 'formulaireRendezvous',
        email: contact.email,
        firstName: contact.firstName,
        lastName: contact.lastName,
      });
    }
  });

  //Click on phone
  $(document).on('click', 'a[href^="tel:"]', function () {
    window.dataLayer.push({
      event: 'ClicTelephone',
    });
  });

  //Click on email
  $(document).on('click', 'a[href^="mailto:"]', function () {
    window.dataLayer.push({
      event: 'ClicEmail',
    });
  });
}
